
import { Component, Vue } from "vue-property-decorator";

import { objAny } from "@/common/common-interface";
import piSelectOper from "@/components/select-oper/select-oper.vue";
import { getOptionList, optionKey } from "@/api/api-dict";

import piSelectTableData from "@/components/select-table-data/select-table-data.vue";
import { getMerchantInfo } from "@/api/api-operation-service";

import i18n from "@/config/i18n";
@Component({
  components: {
    piSelectOper,
    piSelectTableData
  }
})
export default class PiWithdrawForm extends Vue {
  private ruleInline = {};
  private formInline: objAny = {
    address: "",
    bankAccountName: "",
    bankAccountNo: "",
    bankDeposit: "",
    contacts: "",
    contactsMail: "",
    createTime: "",
    fullName: "",
    merchantPkId: "",
    oprName: "",
    oprPkId: "",
    cooperationDeadline: "",
    registerUserVos: [
      {
        effectiveTime: "",
        expireTime: "",
        userName: "",
        userPkId: ""
      }
    ],
    serviceChargeRules: {
      rules: [
        {
          fee: 0,
          fromValue: 0,
          toValue: 0
        }
      ]
    },
    settlementRules: {
      rules: [
        {
          amountType: 0,
          base: 0,
          fromValue: 0,
          ruleType: 0,
          toValue: 0
        }
      ]
    },
    shortName: "",
    staCount: 0,
    telephone: "",
    version: 0,
    loginUrl: ""
  };

  private loading = false;

  private tableList: object[] = [];
  private tableColumns: object[] = [
    {
      title: i18n.t("addMerchant.userName"),
      key: "userName",
      minWidth: 110
    },
    {
      title: i18n.t("addMerchant.userPwd"),
      key: "passWord",
      minWidth: 110
    },
    {
      title: i18n.t("addMerchant.effectiveTime"),
      key: "effectiveTime",
      sortable: true,
      minWidth: 110
    },
    {
      title: i18n.t("addMerchant.expireTime"),
      key: "expireTime",
      sortable: true,
      minWidth: 140
    }
  ];

  private amountTypeObj: objAny = {};
  async getOptionList() {
    const ret = await getOptionList([optionKey.modeType]); //请求字典
    const data = ret[optionKey.modeType]; // 分成方式
    this.amountTypeObj = {};
    data.forEach(e => {
      this.amountTypeObj[e.itemKey] = e.itemValue;
    });
  }
  async getMerchantInfo() {
    const ret = await getMerchantInfo({});
    if (ret.status == this["$config"].apiStatus) {
      this.formInline = ret.data[0];
      const list = ret.data[0].registerUserVos;
      const passWord = "******";
      list.map((item: objAny) => {
        item.passWord = passWord;
      });
      this.tableList = list;
      this.formInlinePassw.userPkId = ret.data[0].registerUserVos[0].userPkId;
    }
  }
  mounted() {
    this.getOptionList();

    this.getMerchantInfo();
  }
  beforeRouteEnter(to: objAny, from: objAny, next: Function) {
    if (from.path.indexOf(to.path) != -1) {
      // 从子页面回来
      const name = to.path;
      next((that: objAny) => {
        const formInline = that["$common"].get(name);
        that.formInline = Object.assign(that.formInline, formInline);
      });
    } else {
      next();
    }
  }
  beforeRouteLeave(to: objAny, from: objAny, next: Function) {
    const name = from.path;
    this["$common"].save(name, this.formInline);
    next();
  }
}
